module.exports = __webpack_public_path__ + "static/media/placeholder.6636b312.svg";